import { useTypedQuery } from "hooks";
import { IncompleteTyresQueryKeys } from "modules/IncompleteTyresDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { EditTyreFormValues } from "modules/IncompleteTyresDashboard/components/EditTyreModal/components/EditTyreForm";

export type SearchCompleteTyresPayload = Omit<EditTyreFormValues, "size" | "season"> & {
  size: number;
  season: number | null;
};

export const useSearchCompleteTyresQuery = (searchPayload: SearchCompleteTyresPayload) =>
  useTypedQuery({
    queryKey: IncompleteTyresQueryKeys.searchCompleteTyres,
    queryFn: async ({ baseUrl, endpoint }) => (await ApiInstance.post(endpoint, searchPayload, baseUrl)).data.tyres,
    refetchOnDependencies: [searchPayload]
  });
